import React from 'react';
import { BoxIcon } from 'lucide-react';
interface BenefitCardProps {
  icon: BoxIcon;
  title: string;
  description: string;
}
export function BenefitCard({
  icon: Icon,
  title,
  description
}: BenefitCardProps) {
  return <div className="bg-paper p-8 rounded-2xl shadow-soft border border-subtle-gray hover:border-storm-red/30 transition-colors" data-id="element-113">
      <div className="w-14 h-14 bg-off-white rounded-xl flex items-center justify-center mb-6 text-storm-red transform -skew-x-6" data-id="element-114">
        <Icon className="w-7 h-7 transform skew-x-6" data-id="element-115" />
      </div>
      <h3 className="text-2xl mb-3 text-ink" data-id="element-116">{title}</h3>
      <p className="text-gray-warm leading-relaxed" data-id="element-117">{description}</p>
    </div>;
}